// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-nav-outer-toolbar {\n  flex-direction: column;\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.layout-header {\n  z-index: 1501;\n}\n\n.layout-body {\n  flex: 1 1;\n  min-height: 0;\n}\n\n.content {\n  flex-grow: 1;\n}", ""]);
// Exports
module.exports = exports;
